import TablePage from '@/found/components/table_page';

export default {
  name: 'terminal_order',
  extends: TablePage,
  data() {
    return {};
  },
  components: {

  },
  created() {
    this.getConfigList('terminal_order_list');
  },
  methods: {
    modalClick({ val, row }) {
    },
  },
};
